import { createAction } from '@reduxjs/toolkit';
import type { AxiosResponse } from 'axios';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsResourcesResponse } from 'app-components/flux/core/resourceStoreTypes';

import type { TickerLogoProps } from './tickerLogosTypes';

export const getTickerLogos = createAction('GET_TICKER_LOGOS', getPayloadCreator<{ tickers: string[] } | void>());

export const getTickerLogosSelected = createAction(
  'GET_TICKER_LOGOS_SELECTED',
  getPayloadCreator<{ tickers: string[] }>(),
);
export const getTickerLogosSelectedSuccess = createAction(
  'GET_TICKER_LOGOS_SELECTED_SUCCESS',
  getPayloadCreator<AxiosResponse<QcsResourcesResponse<TickerLogoProps>>>(),
);
export const getTickerLogosSelectedFailure = createAction('GET_TICKER_LOGOS_SELECTED_FAILURE', errorPayloadCreator);

export const getTickerLogosUpdates = createAction(
  'GET_TICKER_LOGOS_UPDATES',
  getPayloadCreator<{ tickers: string[] }>(),
);
export const getTickerLogosUpdatesSuccess = createAction(
  'GET_TICKER_LGOGS_UPDATES_SUCCESS',
  getPayloadCreator<AxiosResponse<QcsResourcesResponse<TickerLogoProps>>>(),
);
export const getTickerLogosUpdatesFailure = createAction('GET_TICKER_LOGOS_UPDATES_FAILURE', errorPayloadCreator);
